import axios from 'axios';
import config from '../config/config';

class ScheduleApi {
    static importShifts(file) {
        let formData = new FormData();
        formData.append('file', file);
        return axios.post(config.server.endpoint + 'backend/schedule/import', formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    }

    static exportShifts() {
        return axios.get(`${config.server.endpoint}backend/schedule/export`, {
            responseType: 'blob'
        });
    }

    static deleteShifts() {
        return axios.put(`${config.server.endpoint}backend/schedule/delete`);
    }
}

export default ScheduleApi;
